// extracted by mini-css-extract-plugin
export default {"table":"TableORA_table__f5a+m","th":"TableORA_th__HfHtq","tbody":"TableORA_tbody__A19ES","td":"TableORA_td__xMbC4"};